module.exports = __webpack_public_path__ + "img/bni.65d1c2af.png";